import React from 'react'
import { DetailRow } from '@pandiafi/components'
import { useTranslation } from 'react-i18next'

import {
  ContractModificationRequest,
  ContractTenant,
} from '../../../../common/validations'
import { getTenantName } from '../../../utils/getTenantName'

import { Section } from 'components'
import { renderDate } from 'utils'
import { CardTitleBand } from 'components/CardTitleBand/CardTitleBand'

type PreviewData = Omit<ContractModificationRequest, 'id'>

interface ContractModificationRequestPreviewProps {
  contractModificationRequest: PreviewData
  tenants: ContractTenant[]
}

export const ContractModificationRequestPreview: React.FC<
  ContractModificationRequestPreviewProps
> = ({ contractModificationRequest, tenants }) => {
  const { t } = useTranslation(['common', 'contractModification'])

  const { inEffect, description, removeTenantEvents, transferTenantEvent } =
    contractModificationRequest

  const terminatedTenants = tenants.filter((tenant) =>
    removeTenantEvents.some(
      (removeTenant) => removeTenant.removeTenantId === tenant.id
    )
  )

  const newContractParty = tenants.find(
    (tenant) => tenant.id === transferTenantEvent?.destinationTenantId
  )

  return (
    <>
      <CardTitleBand>
        {t('contractModification:headings.modificationPreview')}
      </CardTitleBand>
      <Section className="mb-12">
        <DetailRow>
          {terminatedTenants.length > 0 && (
            <DetailRow.Item
              title={t('contractModification:labels.movingOutTenant')}
            >
              {terminatedTenants.map((tenant) => (
                <span key={tenant.id}>{getTenantName(tenant)}</span>
              ))}
            </DetailRow.Item>
          )}
          <DetailRow.Item
            title={t('contractModification:labels.movingOutDate')}
          >
            {renderDate(inEffect)}
          </DetailRow.Item>
          {description && (
            <DetailRow.Item
              title={t('contractModification:labels.modificationDescription')}
              preLine
            >
              {description}
            </DetailRow.Item>
          )}
          {newContractParty && (
            <DetailRow.Item
              title={t('contractModification:labels.newContractParty')}
            >
              {getTenantName(newContractParty)}
            </DetailRow.Item>
          )}
        </DetailRow>
      </Section>
    </>
  )
}
